module.exports = __webpack_public_path__ + "static/media/keith_dancing_blur.e01518dd.jpg";